<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb"/>
    <div class="flexBox">
      <text-title mainTitle="查看当前门禁设备" subheading="" />
      <div class="header-btn-box">
        <a @click="ToModifyDevice">修改</a>
        <a @click="strategyCenter">返回</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="line-text">设备名称：</div>
        <div>{{deviceName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">设备编号：</div>
        <div>{{deviceCode || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">设备类型：</div>
        <div>{{deviceTypeName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">设备厂家：</div>
        <div>{{deviceManufacturerName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">设备型号：</div>
        <div>{{deviceModelName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">接入协议：</div>
        <div>{{protocolType || '无'}}</div>
      </div>
      <div class="form-line" v-if="parentName">
        <div class="line-text">所属网关：</div>
        <div>{{parentName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">开门计划：</div>
        <div>{{openPlanName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">应用场景：</div>
        <div>{{scenceName || '无'}}</div>
      </div>
      <div class="form-line" v-if="roomNumber && scence === '2'">
        <div class="line-text">设备所在房间：</div>
        <div>{{roomNumber || '无'}}</div>
      </div>
      <div class="form-line" v-if="scence === '2'">
        <div class="line-text">设备所在住户：</div>
        <div>{{enterpriseName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">进出类型：</div>
        <div>{{passTypeText || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">设备用途：</div>
        <div>{{devicePurposeText || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">设备位置：</div>
        <div>{{location || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">责任人：</div>
        <div>{{responsiblePersonName || '无'}}</div>
      </div>
    </form>
  </div>
</template>

<script>
import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
import {commonConfig} from '../common'
import {errorHandler} from '../../../utils/errorHandler'
import InputTree from '../../../components/common/inputs/input-tree'
import {api} from '../../api/access-ctrl'
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'

export default {
  components: {
    TextTitle,
    Breadcrumb,
    InputTree,
    BreadCrumb
  },
  name: 'current-device',
  data () {
    return {
      config: {
        breadcrumb: [{
          value: '智慧门禁',
          name: 'accessCtrlDeviceManagementCenter'
        }, {
          value: '设备管理',
        }],
        tree: {
          fetch: () => api.getBusinessTreeList().then(list => {
            list.forEach(tree => {
              tree._value = tree.id
              tree._label = tree.label = tree.businessEntityName
            })
            return list
          })
        }
      },
      scence: '',
      roomNumber: '',
      deviceName: '',
      deviceCode: '',
      deviceManufacturerName: '',
      deviceModelName: '',
      protocolType: '',
      enterpriseName: '',
      openPlanName: '',
      openPlanIdList: [],
      organization: '',
      scenceName: '',
      scenceList: [
        {code: '1', name: '公共场景'},
        {code: '2', name: '住户场景'},
        {code: '4', name: '预约场景'},
        {code: '3', name: '其他场景'},
        {code: '5', name: '看房场景'}
      ],
      deviceTypeName: '',
      deviceTypeList: [
        {code: '1', name: '二维码云门禁一体机'},
        {code: '2', name: '二维码签到终端'},
        {code: '3', name: '人脸识别终端'},
        {code: '4', name: '人脸签到终端'},
        {code: '5', name: '二维码云门禁控制器'},
        {code: '6', name: '二维码核身终端'},
        {code: '7', name: '人脸闸机网关'},
        
      ],
      passTypeText: '',
      devicePurposeText: '',
      location: '',
      responsiblePersonName: '',
      responsiblePersonList: [],
      parentName: '',
      buildingName: [],
      buildingData: [],
      hasResponsiblePerson: true,
      currentID: '',
    }
  },
  created () {
    this.organization = window.sessionStorage.getItem('organization')
    this.currentID = this.$route.params.id
    this.getOpenPlanList()
    // this.getResponsiblePersonList()
    // this.getBuildingData()
  },
  methods: {
    getAccessDeviceData (code) {
      api.getAccessDeviceByCode(code)
        .then(data => {
          this.roomNumber = data.roomNumber
          this.deviceName = data.deviceName
          this.deviceCode = data.deviceCode
          this.deviceManufacturerName = data.deviceManufacturerName
          this.deviceModelName = data.deviceModelName
          this.protocolType = data.protocolType
          this.enterpriseName = data.enterpriseName
          this.scence = data.scence
          this.parentName = data.parentName
          this.location = data.location
          this.deviceTypeList.map(v => {
            if (v.code === data.deviceType) {
              this.deviceTypeName = v.name
            }
          })
          if (data.deviceType === '3' || data.deviceType === '4') {
            this.hasResponsiblePerson = false
          } else {
            this.hasResponsiblePerson = true
          }
          this.scenceList.map(v => {
            if (v.code === data.scence) {
              this.scenceName = v.name
            }
          })
          if (data.passType === '1') {
            this.passTypeText = '进'
          } else if (data.passType === '2') {
            this.passTypeText = '出'
          } else if (data.passType === '3') {
            this.passTypeText = '进/出'
          }
          if (data.devicePurpose === '1') {
            this.devicePurposeText = '仅门禁'
          } else if (data.devicePurpose === '2') {
            this.devicePurposeText = '仅考勤'
          } else if (data.devicePurpose === '3') {
            this.devicePurposeText = '门禁和考勤'
          }
          this.openPlanName = data.openPlanName
          this.responsiblePersonName = data.responsiblePersonName
          this.buildingData.map(v => {
            if (v.id === data.buildingId) {
              this.buildingName = v.dormitoryName
              this.buildingData.map(val => {
                if (v.parentId === val.id) {
                  this.buildingName = val.dormitoryName + '/' + this.buildingName
                  this.buildingData.map(value => {
                    if (val.parentId === value.id) {
                      this.buildingName = value.dormitoryName + '/' + this.buildingName
                    }
                  })
                }
              })
            }
          })
        })
        .catch(errorHandler('获取设备数据失败'))
      // this.$axios.get(httpUrl.test + this.school + '/accessDevice/getById/' + id, {})
      //   .then((res) => {

      //   })
      //   .catch(errorHandler('获取设备数据失败'))
    },
    getOpenPlanList () {
      api.getOpenPlanList()
        .then(data => {
          this.openPlanIdList = data
          if (this.openPlanIdList.length > 0) {
            this.openPlanId = this.openPlanIdList[0].id
          }
          this.getAccessDeviceData(this.currentID)
        })
        .catch(errorHandler('获取开门计划失败'))
    },
    // getResponsiblePersonList () {
    //   api.getBasePersonList('')
    //     .then(list => {
    //       list.forEach(it => {
    //         it._value = it.id
    //         it._label = `${it.accountName}  /  ${it.actualName}  /  ${it.accountBelongName}`
    //       })
    //       this.responsiblePersonList = list
    //     })
    // },
    // getBuildingData () {
    //   this.$axios.post(httpUrl.test + this.school + '/dorm/dormitory/getList', {})
    //     .then((res) => {
    //       let list = res.body.data
    //       let newArr = []
    //       list.map(v => {
    //         if (v.level > 1 && v.level < 5) {
    //           newArr.push(v)
    //         }
    //       })
    //       this.buildingData = newArr
    //     })
    //     .catch(errorHandler('获取数据失败'))
    // },
    strategyCenter () {
      this.$router.push({
        path: '/access-control/device/center'
      })
    },
    ToModifyDevice () {
      this.$router.push({
        path: '/access-control/device/modify/' + this.$route.params.id
      })
    }
  }
}
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 30px 0;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 120px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/view/AccessCtrl/device-management/current-device.vue